import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import styles from "./App.module.css";
import Header from "./components/Header/Header";
import Culture from "./page/Culture/Culture";
import FAQ from "./page/FAQ/FAQ";
import Footer from "./page/Footer/Footer";
import InputApply from "./page/InputApply/InputApply";
import Job from "./page/Job/Job";
import JobDetail from "./page/JobDetail/JobDetail";
import Main from "./page/Main/Main";
import Submission from "./page/Submission/Submission";

import getGA from "./service/ga.js";
function App() {
  const [isSidebar, setIsSidebar] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  const [isSelect, setIsSelect] = useState("");
  const { pathname } = useLocation();
  const select = (menu) => {
    return isSelect === menu;
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useEffect(() => {
    const bgMode = window.localStorage.getItem("bgMode");
    if (bgMode === "dark") {
      document.getElementsByTagName("html")[0].classList.add("ui-dark");
      setIsDarkMode(true);
    } else {
      setIsDarkMode(false);
    }
  }, []);
  const darkOnOff = () => {
    if (
      document.getElementsByTagName("html")[0].classList.contains("ui-dark")
    ) {
      document.getElementsByTagName("html")[0].classList.remove("ui-dark");
      localStorage.setItem("bgMode", "light");
      setIsDarkMode(false);
    } else {
      document.getElementsByTagName("html")[0].classList.add("ui-dark");
      localStorage.setItem("bgMode", "dark");
      setIsDarkMode(true);
    }
  };

  return (
    <>
      <Header
        setIsDarkMode={setIsDarkMode}
        isDarkMode={isDarkMode}
        darkOnOff={darkOnOff}
        isSidebar={isSidebar}
        setIsSidebar={setIsSidebar}
        select={select}
        setIsSelect={setIsSelect}
        isSelect={isSelect}
      />
      <div className={styles.App}>
        <Routes>
          <Route
            exact={true}
            path="/"
            element={<Main isDarkMode={isDarkMode} />}
          />
          <Route
            path="/culture"
            element={<Culture isDarkMode={isDarkMode} />}
          />
          <Route
            path="/position"
            element={<Job isDarkMode={isDarkMode} isSidebar={isSidebar} />}
          />
          <Route path="/faq" element={<FAQ isDarkMode={isDarkMode} />} />
          <Route
            path="/position/:id"
            element={<JobDetail isDarkMode={isDarkMode} />}
          />
          <Route
            path="/position/apply"
            element={<InputApply isDarkMode={isDarkMode} />}
          />
          <Route
            path="/position/submission"
            element={<Submission isDarkMode={isDarkMode} />}
          />
        </Routes>
      </div>

      <Footer
        isSidebar={isSidebar}
        setIsSidebar={setIsSidebar}
        select={select}
        setIsSelect={setIsSelect}
        isSelect={isSelect}
      />
    </>
  );
}

export default App;
